import { Modal, Toast } from 'antd-mobile'
import { getAuthInfo } from './tool'
import { downloadLink } from './constant'

function callHandler(name: string, params: any = {}, callback: any = () => { }) {
  window.bridge.callHandler(name, params, callback)
}

function registerHandler(name: string, handler: any = () => { }) {
  window.bridge.registerHandler(name, handler)
}

export function waitBridge(time = 10) {
  let t = time
  let handler: NodeJS.Timer
  function check(resolve: (n: boolean) => void) {
    if (!t) {
      console.log('waitBridge fail')
      handler && clearInterval(handler)
      return resolve(false)
    }
    if (window.bridge) {
      console.log('waitBridge time', t)
      handler && clearInterval(handler)
      return resolve(true)
    }
  }
  return new Promise((resolve) => {
    check(resolve)
    handler = setInterval(() => {
      t = t - 1
      check(resolve)
    }, 200)
  })
}

export async function getUserInfo(): Promise<User.BasicInfo | undefined> {
  let auth = getAuthInfo()
  if (!window.bridge && (window.isAndroid || window.isIOS) && !auth) {
    await waitBridge()
  }

  const isInApp = !!window.bridge
  try {
    if (isInApp) {
      auth = await new Promise((resolve) =>
        callHandler('getUserInfo', {}, resolve)
      )
    }
  } catch (e) {
    return
  }

  return auth
}

export function goBack() {
  const isInApp = !!window.bridge
  if (isInApp) {
    callHandler('goBack')
    return
  }

  window.history.back()
}

export function exit() {
  const isInApp = !!window.bridge;
  if (isInApp) {
    callHandler('exit');
    return;
  }

  window.history.back();
}

export function toast(msg: string) {
  const isInApp = !!window.bridge
  if (isInApp) {
    callHandler('showToast', { msg })
    return
  }

  Toast.show({ content: msg })
}

export function alert(msg: string) {
  const isInApp = !!window.bridge
  if (isInApp) {
    return new Promise((resolve) => {
      const handler = setTimeout(() => resolve(false), 30 * 60 * 1000)
      registerHandler('confirmAck', (confirm: boolean) => {
        clearTimeout(handler)
        resolve(confirm)
      })
      callHandler('showAlert', { msg })
    })
  }

  return Modal.confirm({
    content: msg
  })
}

export function selectPhoto(): Promise<string | null> {
  const isInApp = !!window.bridge;
  if (isInApp) {
    return new Promise((resolve) => {
      registerHandler('uploadFileAck', ({ url }: { url: string }) => resolve(url));
      callHandler('popUploadFile', { fileType: 0 });
    });
  }

  return Promise.resolve(null);
}

export function selectVideo(): Promise<Video | null> {
  const isInApp = !!window.bridge;
  if (isInApp) {
    return new Promise((resolve) => {
      registerHandler('uploadFileAck', (result: Video) => resolve(result));
      callHandler('popUploadFile', { fileType: 1 });
    });
  }

  return Promise.resolve(null);
}

export function setBusinessStatus(type: number) {
  const isInApp = !!window.bridge
  if (isInApp) {
    callHandler('setBusinessInfo', { type })
  }
}

export function openPage(page: number, uid?: number) {
  const isInApp = !!window.bridge
  if (isInApp) {
    callHandler('navigationTo', { page, uid })
  }
}

export function shareApp(type: string) {
  const isInApp = !!window.bridge
  if (isInApp) callHandler('share', { link: downloadLink, type })
}

export type DLLogLevel = 'debug' | 'info' | 'warn' | 'error'

/** 写入客户端日志。不传 ticket，msg 由原生截断。 */
export function dlLog(level: DLLogLevel, tag: string, msg: string) {
  if (!window.bridge) return
  callHandler('DLLog', { level, tag, msg })
}

export function notifyCheckInReady() {
  if (!window.bridge) return
  callHandler('checkInReady')
}

export function notifyCheckInUnavailable() {
  if (!window.bridge) return
  callHandler('checkInUnavailable')
}

export function notifyCheckInFailed() {
  if (!window.bridge) return
  callHandler('checkInFailed')
}

export function onCheckInShow(handler: () => void) {
  if (!window.bridge) return
  registerHandler('onCheckInShow', handler)
}
